/**
 * Export loadData calls from ducks modules of different containers
 */
import {
  loadData as AuthenticationPageLoader,
  loadData,
} from './AuthenticationPage/AuthenticationPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { setInitialValues as CheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as ManageListingsPageLoader } from './ManageListingsPage/ManageListingsPage.duck';
import { loadData as BookAShiftListPageLoader } from './BookAShiftListPage/BookAShiftListPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';
import {
  loadData as TransactionPageLoader,
  setInitialValues as TransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';
import { loadData as AdminStaffPageLoader } from './AdminStaffPage/AdminStaffPage.duck';
import { loadData as AdminBusinessPageLoader } from './AdminBusinessPage/AdminBusinessPage.duck';

import { loadData as WorkerProfileAdminViewPageLoader } from './WorkerProfileViewPage/WorkerProfileAdminViewPage.duck';
import { loadData as BusinessCheckoutPageLoader } from './BusinessCheckoutPage/BusinessCheckoutPage.duck';
import { loadData as ListingPublishedPageLoader } from './ListingPublishedPage/ListingPublishedPage.duck';
import { loadData as BusinessStaffPageLoader } from './BusinessDashboardPages/BusinessDashboard.duck';
import { loadData as WorkerDashboardPageLoader } from './WorkerDashboardPage/WorkerDashboardPage.duck';
import { loadData as ApplicantShowingPageLoader } from './ApplicantShowingPage/ApplicantShowPage.duck';
import { loadData as MessagePageLoader } from './MessagePage/MessagePage.duck';
import { loadData as SuperAdminBusinessDetailsPageLoader } from './SuperAdminBusinessDetailsPage/SuperAdminBusinessDetailsPage.duck';
import { loadData as WorkerGigDetailsPageLoader } from './WorkerGigDetailsPage/WorkerGigDetailsPage.duck';
import { loadData as BusinessDashboardInvoicePageLoader } from './BusinessDashboardPages/BusinessDashboardInvoicePage.duck';
import { loadData as BusinessTimeStatementDetailsPageLoader } from './BusinessDashboardPages/BusinessDashboardTimeStatementDetailsPage/BusinessDashboardTimeStatementDetailsPage.duck';
import { loadData as WorkerTimeStatementPageLoader } from './WorkerTimestatementPage/WorkerTimestatement.duck';
import { loadData as WorkerTimeStatementDetailsPageLoader } from './WorkerTimestatementDetailsPage/WorkerTimestatementDetails.duck';
import { loadData as AdminTimestatementDetailsPageLoader } from './AdminTimestatementDetailsPage/AdminTimestatementDetailsPage.duck';
const getPageDataLoadingAPI = () => {
  return {
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CheckoutPage: {
      setInitialValues: CheckoutPageInitialValues,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    ManageListingsPage: {
      loadData: ManageListingsPageLoader,
    },
    BookAShiftListPage: {
      loadData: BookAShiftListPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
    },
    WorkerDashboardPage: {
      loadData: WorkerDashboardPageLoader,
    },
    ApplicantShowingPage: {
      loadData: ApplicantShowingPageLoader,
    },
    SuperAdminBusinessDetailsPage: {
      loadData: SuperAdminBusinessDetailsPageLoader,
    },
    WorkerGigDetailsPage: {
      loadData: WorkerGigDetailsPageLoader,
    },
    MessagePage: {
      loadData: MessagePageLoader,
    },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
    AdminStaffPage: {
      loadData: AdminStaffPageLoader,
    },
    AdminBusinessPage: {
      loadData: AdminBusinessPageLoader,
    },
    WorkerProfileAdminViewPage: {
      loadData: WorkerProfileAdminViewPageLoader,
    },
    BusinessCheckoutPage: {
      loadData: BusinessCheckoutPageLoader,
    },
    ListingPublishedPage: {
      loadData: ListingPublishedPageLoader,
    },
    BusinessDashboardStaffPage: {
      loadData: BusinessStaffPageLoader,
    },
    BusinessDashboardInvoicePage: {
      loadData: BusinessDashboardInvoicePageLoader,
    },
    BusinessTimeStatementDetailsPage: {
      loadData: BusinessTimeStatementDetailsPageLoader,
    },
    WorkerTimeStatementPage: {
      loadData: WorkerTimeStatementPageLoader,
    },
    WorkerTimeStatementDetailsPage: { loadData: WorkerTimeStatementDetailsPageLoader },
    AdminTimestatementDetailsPage: { loadData: AdminTimestatementDetailsPageLoader },
  };
};

export default getPageDataLoadingAPI;
